
import {
  AlertCircle,
  ArrowDown,
} from 'lucide-react';

import Header from '../../../features/dashboard/components/Header';

import ReportCard from '../reports/components/ReportCard';
import usePublicReport from '../reports/hooks/usePublicReport';
import ReportSidebar from '../AccessAdministration/pages/ReportSidebar';

const PublicReportPage = () => {
  const { data, loading, error } = usePublicReport();

  return (
    <main className="min-h-screen bg-[#eef3f8] text-slate-900">
      <Header />

      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -right-40 -top-40 h-[420px] w-[420px] rounded-full bg-teal-100/40 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 h-[420px] w-[420px] rounded-full bg-slate-200/50 blur-3xl" />
      </div>

      <div className="relative z-10 flex min-h-[calc(100vh-72px)]">
        {/* Permission-based sidebar */}
        <ReportSidebar />

        {/* Main content */}
        <div className="min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-8">
          <div className="mx-auto w-full max-w-[1440px]">
            {loading ? (
              <section
                className="flex min-h-[50vh] flex-col items-center justify-center"
                aria-live="polite"
              >
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600" />

                <p className="mt-4 text-sm font-medium text-slate-700">
                  Loading report permissions...
                </p>
              </section>
            ) : error || !data ? (
              <section className="flex min-h-[50vh] items-center justify-center">
                <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white px-6 py-8 text-center shadow-sm">
                  <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-rose-50 text-rose-600">
                    <AlertCircle size={23} strokeWidth={1.8} />
                  </div>

                  <h2 className="mt-4 text-base font-semibold text-slate-900">
                    Unable to load reports
                  </h2>

                  <p className="mx-auto mt-2 max-w-sm text-sm leading-6 text-slate-500">
                    {error || 'We could not load the available reports.'}
                  </p>
                </div>
              </section>
            ) : (
              <section>
                <div className="mb-4 flex items-center justify-between">
                  <div>
                    <h2 className="text-base font-semibold text-slate-900">
                      Available Reports
                    </h2>

                    <p className="mt-1 text-sm text-slate-500">
                      Select a report you have permission to access.
                    </p>
                  </div>

                  <div className="hidden items-center gap-1.5 text-xs text-slate-400 sm:flex">
                    <ArrowDown size={14} strokeWidth={1.7} />
                    <span>Select a report below</span>
                  </div>
                </div>

                {data.reports.length === 0 ? (
                  <div className="rounded-xl border border-slate-200 bg-white px-6 py-10 text-center">
                    <p className="text-sm font-medium text-slate-700">
                      No reports available
                    </p>

                    <p className="mt-1 text-sm text-slate-500">
                      Your selected role does not have access to any reports.
                    </p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                    {data.reports.map((report, index) => (
                      <ReportCard
                        key={report.id}
                        report={report}
                        index={index}
                      />
                    ))}
                  </div>
                )}
              </section>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default PublicReportPage;
